import {Component, OnInit} from '@angular/core';
import {AccessManagementService} from 'src/app/services/access-management.service';
import {roles} from 'src/app/shared/utils/roles';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss'],
})
export class SettingsComponent implements OnInit {
  isTechStackandPositionAccess = false;
  isHolidaysandOfficesAccess = false;
  constructor(private access: AccessManagementService) {}

  ngOnInit(): void {
    this.isTechStackandPositionAccess = this.access.checkPermissions([
      ...roles.CEO,
      ...roles.RECRUITMENT_DEPARTMENT,
      ...roles.HR_DEPARTMENT,
      ...roles.DELIVERY_DEPARTMENT,
    ]);
    this.isHolidaysandOfficesAccess = this.access.checkPermissions([
      ...roles.CEO,
      ...roles.ACCOUNTANT_DEPARTMENT,
      ...roles.HR_DEPARTMENT,
    ]);
  }
}
